import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import { formatDateTime } from '../utilities/timeUtilities';
import { useNavigate } from 'react-router-dom';


function formatDate(dateString) 
{
    const date = new Date(dateString);

    const formattedDate = date.toLocaleDateString("en-GB").replace(/\//g, '-');

    return formattedDate
}
const UpcomingShowsItem = ({show}) => {

    const navigate = useNavigate();

    function handleItemClick(item) {
        // history.push(`/show/${item.id}`);
        navigate(`/show/${item.id}`);
    }

    return (

        <div className="col">

            <Card  >
                <Card.Body>
                    <Card.Title
                    onClick={() => handleItemClick(show)}
                    style={{
                        cursor: 'pointer'
                    }}>{show.name}</Card.Title>
                    <p>Status : <Badge bg="primary">{show.status}</Badge></p>
                    <p>Start Date and Time : {formatDateTime(show.startDateTime)}  </p>
                    {

                        show.websiteUrl && <a href={show.websiteUrl} target="_blank" rel="noreferrer" className='btn btn-azure'>View Website</a>
                    } 
                    
                </Card.Body>
            </Card>
        </div>
    );
}

export default UpcomingShowsItem;
